import { AlertBox, Box } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { ItemDocumentConversionFailureModal } from './ItemDocumentConversionFailureModal';
import { useLineItemReorderActionStatus } from '../../contexts/LineItemReorderActionStatusContext';
import { useSourcePageContext } from '../../contexts/SourcePageContext';
import { BUY_IT_AGAIN_SOURCE_PAGE } from '../../../constants/sourcePage';
import { BIACheckoutLink } from './BIACheckoutLink';

export const LineItemReorderActionFeedback = () => {
  const [
    errorMessages = {},
    buyItAgainMessages = {},
    orderabilityMessages = {},
  ] = useTranslations([
    'errorMessages',
    'buyItAgainMessages',
    'orderabilityMessages',
  ]);

  const { sourcePage } = useSourcePageContext();

  const {
    addToCartSuccess,
    addToCartFailure,
    productUnavailableFailure,
    docConversionFailure,
    designUpdateInProgress,
    genericFailure,
  } = useLineItemReorderActionStatus();

  if (designUpdateInProgress) {
    return (
      <AlertBox skin="standard" my={3}>
        {buyItAgainMessages.designUpdateInProgress}
      </AlertBox>
    );
  }

  if (addToCartFailure) {
    return (
      <AlertBox skin="error" my={3}>
        {errorMessages.addToCartFailure}
      </AlertBox>
    );
  }

  if (addToCartSuccess) {
    return (
      <AlertBox skin="success" my={3}>
        {buyItAgainMessages.addToCartSuccessMessage}
        {sourcePage === BUY_IT_AGAIN_SOURCE_PAGE && (
          <Box>
            <BIACheckoutLink />
          </Box>
        )}
      </AlertBox>
    );
  }

  if (productUnavailableFailure) {
    return (
      <AlertBox skin="warning" my={3}>
        {orderabilityMessages.productNoLongerAvailable}
      </AlertBox>
    );
  }

  if (docConversionFailure) {
    return <ItemDocumentConversionFailureModal isOpen={docConversionFailure} />;
  }

  if (genericFailure) {
    return (
      <AlertBox skin="error" my={3}>
        {errorMessages.defaultErrorDetails}
      </AlertBox>
    );
  }

  return null;
};
